<template>
  <main class="app-main">
    <keep-alive>
      <router-view />
    </keep-alive>
  </main>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'Dashboard',

    computed: {
        ...mapState('account', {
            accountId: state => state.accountId,
            userRole: state => state.userRole,
            allocationDashboardActivated: state => state.settings.allocationDashboardActivated
        }),
        ...mapState('dashboard', {
            activeTab: state => state.activeTab
        }),

        isWeboAdmin() {
            return this.userRole === 'webo_admin'
        },

        isWeboEmployee() {
            return this.userRole === 'webo_employeee'
        },

        isDashboardAccessAllowed() {
            return this.allocationDashboardActivated && (this.isWeboAdmin || this.isWeboEmployee || this.$store.getters['account/getAccessToMonitoring']())
        }
    }
}
</script>
